import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import {
  ErrorOutline,
  ExpandMore,
  InfoOutlined,
  Rule,
  Schedule,
} from '@mui/icons-material';

export const Metric = ({ label, value, icon: Icon, color }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      height: '100%',
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {value ?? 0}
        </Typography>
      </Box>
      <Icon sx={{ color, fontSize: 30 }} />
    </Stack>
  </Paper>
);

const DetailMetric = ({ label, value, icon: Icon, color }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{
      p: 1.5,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      minHeight: 72,
    }}
  >
    <Box>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {value ?? 0}
      </Typography>
    </Box>
    <Icon sx={{ color, fontSize: 26 }} />
  </Stack>
);

const CompletedProjectMetricsAccordion = ({ metrics }) => {
  const missingByType = metrics?.completed_project_missing_by_type || {};

  return (
    <Accordion
      elevation={0}
      disableGutters
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        minHeight: '100%',
        '&:before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          minHeight: 84,
          px: 2,
          py: 0.5,
          '&.Mui-expanded': {
            minHeight: 84,
          },
          '& .MuiAccordionSummary-content': {
            my: 0,
            alignItems: 'center',
            alignSelf: 'stretch',
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            my: 0,
          },
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              Contratos con datos pendientes
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {metrics?.completed_project_pending_contracts ?? 0}
            </Typography>
          </Box>
          <Rule sx={{ color: '#6d4c41', fontSize: 30, mr: 1 }} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} sm={6} md={3}>
            <DetailMetric
              label="Sin fecha poseedor"
              value={missingByType.current_possessor_date}
              icon={InfoOutlined}
              color="#8e24aa"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DetailMetric
              label="Sin seguro vida"
              value={missingByType.life_insurance}
              icon={InfoOutlined}
              color="#00897b"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DetailMetric
              label="Sin seguro incendio"
              value={missingByType.fire_insurance}
              icon={InfoOutlined}
              color="#ef6c00"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DetailMetric
              label="Sin impuesto inmobiliario"
              value={missingByType.real_state_tax}
              icon={InfoOutlined}
              color="#c62828"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export const MetricsBoard = ({ metrics }) => (
  <Grid container spacing={2} sx={{ mb: 2 }}>
    <Grid item xs={12} sm={6} md={3}>
      <Metric
        label="Generadas hoy"
        value={metrics?.generated_today}
        icon={Schedule}
        color="#1976d2"
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <Metric
        label="Errores"
        value={metrics?.failed}
        icon={ErrorOutline}
        color="#d32f2f"
      />
    </Grid>
    <Grid item xs={12} md={6}>
      <CompletedProjectMetricsAccordion metrics={metrics} />
    </Grid>
  </Grid>
);
